import { Button, Stack, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import { addPlacementTracker } from '../../redux/features/generalSlice';
import { Field, Form, FormikProvider, useFormik } from 'formik';
import * as yup from 'yup';
import { useSelector } from 'react-redux';
import useHandleApiResponse from '../../Hooks/useHandleApiResponse';

export default function ChangeTo({ row, setOpen }) {
  const submitLoading = useSelector((state) => state.general.submitLoading);
  const dispatch = useDispatch();
  const apiHelper = useHandleApiResponse();

  const validationSchema = yup.object({
    session_to_complete: yup.number().required('session is required'),
    // email: yup.string().email('must be valid email').required('email is required'),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      course_enrollment_id: row?.course_enrollment_id,
      session_to_complete: 180,
      // email: '',
    },
    onSubmit: (values) =>
      dispatch(addPlacementTracker(values)).then((res) =>
        apiHelper(res, {
          onSuccess: () => {
            setOpen(false);
          },
        }),
      ),
    validationSchema,
  });

  return (
    <FormikProvider value={formik}>
      <Form>
        <Stack gap={2}>
          <Field
            as={TextField}
            label="Session to be Completed"
            name="session_to_complete"
            type="number"
            onWheel={(e) => {
              e.target.blur();
            }}
            error={formik.touched.session_to_complete && Boolean(formik.errors.session_to_complete)}
            helperText={formik.touched.session_to_complete && formik.errors.session_to_complete}
          />
          {/*     <Field
            as={TextField}
            label="Email"
            name="email"
            type="email"
            onWheel={(e) => {
              e.target.blur();
            }}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          /> */}
          <Button
            variant="contained"
            color="success"
            sx={{ color: 'white', alignSelf: 'flex-end' }}
            type="submit"
            disabled={submitLoading}
          >
            {submitLoading ? 'loading...' : 'confirm'}
          </Button>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
